module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"only one asset error":"Zu viele Dateien ausgewählt.","replace file":"Datei ersetzen"}}')
  delete Component.options._Ctor
}
